/**
 * This is an auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import type { ApiEmailStatus, ApiSendEmailRequest, EnumMailingSettingGroup, SendDeliverySlipRequest, SendPrepareInvoiceRequest } from '@Model';
import type { HttpActions, Result } from '@synqo/frontend-component-library';

/**
 * Calls the endpoints of EmailsController.
 */
export class EmailsRepository {
    constructor(private readonly http: HttpActions) {}

    /**
     * Calls POST /emails/send
     */
    public sendEmail(request: ApiSendEmailRequest): Promise<Result<ApiEmailStatus[]>> {
        return this.http.post<Result<ApiEmailStatus[]>, ApiSendEmailRequest>('/emails/send', request);
    }

    /**
     * Calls POST /emails/prepare_delivery_slip_email
     */
    public prepareDeliverySlipEmail(request: SendDeliverySlipRequest): Promise<Result<ApiSendEmailRequest>> {
        return this.http.post<Result<ApiSendEmailRequest>, SendDeliverySlipRequest>('/emails/prepare_delivery_slip_email', request);
    }

    /**
     * Calls POST /emails/prepare_invoice_email
     */
    public prepareInvoiceEmail(request: SendPrepareInvoiceRequest): Promise<Result<ApiSendEmailRequest>> {
        return this.http.post<Result<ApiSendEmailRequest>, SendPrepareInvoiceRequest>('/emails/prepare_invoice_email', request);
    }

    /**
     * Calls GET /emails/placeholders/{groupNumber}
     */
    public getPlaceholders(groupNumber: EnumMailingSettingGroup): Promise<Result<string[]>> {
        return this.http.get<Result<string[]>>(`/emails/placeholders/${groupNumber}`);
    }
}
